import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Button, Tab } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import Base from "../../../Base/views/Base";
import MyEmployeeAccess from "./MyEmployeeAccess";
import UserAccessControlGrid from "./UserAccessControlGrid";
import { useSelector } from "react-redux";

const MyEmployeeAccessLandingPage = () => {
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const myEmployeeAccess = atsModuleData?.find((item) => item.module_name === "My Employee");
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue, calendarValue) => {
    setValue(newValue);
  };
  const [openPopup, setOpenPopup] = useState(false);
  useEffect(() => {
    !myEmployeeAccess && setValue("2")
  },[myEmployeeAccess])
  return (
    <Base>
      <Box sx={{ maxHeight: "calc(100vh - 70px)", overflowY: "auto" }}>
        <TabContext value={value}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <TabList
              sx={{
                minHeight: "40px",
                mb: 1,
                ".MuiTab-root": { minHeight: "20px" },
                "& .MuiTabs-indicator": {
                  width: "100%",
                  display: "flex",
                  justifyContent: "center !important",
                },
              }}
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              orientation="horizontal"
              allowScrollButtonsMobile={true}
            >
             {myEmployeeAccess && <Tab label="Employee" value="1" />}
              <Tab label="Non-Employee" value="2" />
            </TabList>
            <Button
              sx={{
                borderRadius: "8px",
                fontSize: "13px",
                padding: "4px 10px",
                boxShadow: "none",
                marginRight: "10px",
              }}
              size="small"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => setOpenPopup(true)}
            >
             + Create User
            </Button>
          </Box>

          <TabPanel value="1" sx={{ padding: "0px" }}>
            <MyEmployeeAccess openPopup={openPopup} setOpenPopup={setOpenPopup}/>
          </TabPanel>
          <TabPanel value="2" sx={{ padding: "0px" }}>
            <UserAccessControlGrid openPopup={openPopup} setOpenPopup={setOpenPopup} />
          </TabPanel>
        </TabContext>
      </Box>
    </Base>
  );
};

export default MyEmployeeAccessLandingPage;
